import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import ModalPopUp from "@/Components/common/ModalPopUp";
import {
  fetchInvitedCandidates,
  reStateFilters,
  setInvitedCandidatesLoading,
  showFilterModal,
  updatePagination,
  deSelectAllCandidate,
  updateFilters,
} from "@/reducers/client_candidates/candidatesinvited";
import { fetchFiltersData } from "@/reducers/clientscandidates";

import CalendarFilter from "../../../ListingFilters/CalendarFilter";
import CandidateTypeFilter from "../../../ListingFilters/CandidateTypeFilter";
import ComplianceStatusFilter from "../../../ListingFilters/ComplianceStatusFilter";
import DropDownFilter from "../../../ListingFilters/DropDownFilter";
import FilterModalBottomAction from "../../../ListingFilters/FilterModalBottomAction";
import { FilterModalTop } from "../../../ListingFilters/FilterModalTop";
import MilesFilter from "../../../ListingFilters/MilesFilter";
import SessionTypeFilter from "../../../ListingFilters/SessionTypeFilter";
import TextFieldFilter from "../../../ListingFilters/TextFieldFilter";
/**
 * This is a functional component for the filter modal.
 *
 * @return {JSX.Element} The filter modal component
 */
export const FilterModal = () => {
  const dispatch = useDispatch();
  const { showFilters, filters, pagination } = useSelector(
    (state) => state.clientCandidatesInvited,
  );
  const { filterLists } = useSelector((state) => state.clientsCandidates);
  /**
   * Function to handle the close event.
   *
   * @param {boolean} fromBtn - indicates if the event was triggered from a button
   * @return {void}
   */
  const handleClose = (fromBtn = false) => {
    if (fromBtn) {
      dispatch(reStateFilters());
    }
    dispatch(showFilterModal(false));
  };
  useEffect(() => {
    dispatch(fetchFiltersData());
  }, []);
  /**
   * Function to handle the apply action.
   *
   * @return {void}
   */
  const handleApply = () => {
    dispatch(setInvitedCandidatesLoading(true));
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(deSelectAllCandidate());
    dispatch(fetchInvitedCandidates(filters));
    handleClose();
  };
  /**
   * Function to reset filters and fetch invited candidates.
   */
  const handleReset = () => {
    dispatch(updateFilters({}));
    dispatch(setInvitedCandidatesLoading(true));
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(deSelectAllCandidate());
    dispatch(
      fetchInvitedCandidates({
        search: filters.search,
      }),
    );
    handleClose();
  };
  return (
    <ModalPopUp
      show={showFilters}
      panelClass="max-w-[774px]"
      onClose={() => {
        handleClose(true);
      }}
    >
      <div className="grid gap-6">
        <div className="grid gap-[12px]">
          <div className="grid gap-4">
            <FilterModalTop
              handleClose={() => {
                handleClose(true);
              }}
            />
          </div>
          <CandidateTypeFilter
            active={filters.candidateType}
            handleClick={(value) => {
              dispatch(updateFilters({ candidateType: value }));
            }}
          />
          <div className="grid grid-cols-1 gap-x-6 gap-y-[18px] sm:grid-cols-2">
            <SessionTypeFilter
              active={filters.sessionType}
              handleClick={(value) => {
                dispatch(updateFilters({ sessionType: value }));
              }}
            />
            <TextFieldFilter
              handleKeyUp={(e) => {
                if (e.keyCode === 13) {
                  handleApply();
                }
              }}
              handleChange={(value) => {
                dispatch(updateFilters({ candidateReferenceNo: value }));
              }}
              label="Reference No."
              value={filters.candidateReferenceNo}
              filterId="candidateReferenceNo"
              placeholder="Enter Reference No."
            />
            <TextFieldFilter
              handleKeyUp={(e) => {
                if (e.keyCode === 13) {
                  handleApply();
                }
              }}
              handleChange={(value) => {
                dispatch(updateFilters({ candidateName: value }));
              }}
              label="Candidate"
              value={filters.candidateName}
              filterId="candidateName"
              placeholder="Enter Candidate Name"
            />
            <TextFieldFilter
              handleKeyUp={(e) => {
                if (e.keyCode === 13) {
                  handleApply();
                }
              }}
              handleChange={(value) => {
                dispatch(updateFilters({ candidateLicenseNo: value }));
              }}
              label="Prof. Registration No."
              value={filters.candidateLicenseNo}
              filterId="candidateLicenseNo"
              placeholder="GMC/NMC/GPhC"
            />
            <ComplianceStatusFilter
              value={filters.complianceStatus}
              handleChange={(value) => {
                dispatch(updateFilters({ complianceStatus: value }));
              }}
            />
            <DropDownFilter
              options={
                filterLists && filterLists?.allRoles?.length > 0
                  ? filterLists?.allRoles
                  : []
              } // this is the list of roles
              id="candidateRole"
              label="Role"
              placeholder="Select Role"
              value={filters.candidateRole} // selected role
              handleChange={(value) => {
                dispatch(updateFilters({ candidateRole: value }));
              }} // function to handle change of role
            />
            <MilesFilter
              value={filters.miles}
              handleChange={(value) => {
                // console.log(value)
                dispatch(updateFilters({ miles: value }));
              }}
            />
            <DropDownFilter
              options={
                filterLists && filterLists?.allUsers?.length > 0
                  ? filterLists?.allUsers.filter(
                      (user) => user.type !== "candidate",
                    )
                  : []
              } // this is the list of roles
              id="Invited By"
              label="Invited By"
              // isMultiple="false"
              placeholder="Select Invited by"
              value={filters.actionedById} // selected role
              handleChange={(value, type) => {
                dispatch(
                  updateFilters({ actionedById: value, actionedByType: type }),
                );
              }} // function to handle change of role
            />
          </div>
          <div className="_filter_calendar">
            <CalendarFilter
              label="Date Invited (From - To)"
              dateFrom={filters.invitedDateFrom}
              dateTo={filters.invitedDateTo}
              handleChange={(value) => {
                dispatch(
                  updateFilters({
                    invitedDateFrom: value.dateFrom,
                    invitedDateTo: value.dateTo,
                  }),
                );
              }}
            />
          </div>
        </div>
        <FilterModalBottomAction
          applyFunc={handleApply}
          resetFunc={handleReset}
        />
      </div>
    </ModalPopUp>
  );
};
